import { createContext, useContext } from "react";
import type { RunStartInput } from "@calega/content";
import { startExerciseRun } from "./learning-api";

export const RecommendationRunContext = createContext<{ id: string; contentPageId: string } | null>(null);

export function useRecommendationRunStarter() {
  const recommendation = useContext(RecommendationRunContext);
  return function start<Response = { runId: string; exercise: unknown }>(input: RunStartInput) {
    return startExerciseRun<Response>(recommendation && recommendation.contentPageId === input.contentPageId
      ? { ...input, recommendationId: recommendation.id }
      : input);
  };
}
